const FIELD_LABELS = {
  Name: 'Name',
  MainContact: 'Hauptkontakt',
  Salutation: 'Anrede',
  Email: 'E-Mail',
  Phone: 'Telefonnummer',
  Fax: 'Fax',
  GlnNumber: 'GLN-Nummer',
  Language: 'Korrespondenzsprache',
  Street: 'Strasse / Nr.',
  Zip: 'PLZ',
  City: 'Ort',
  Canton: 'Kanton',
  Address: 'Adresse',
  MedicalPerson: 'SM-Person',
  SmMarketingEntity: 'SM-Person/Institution',
  WebAddress: 'Webadresse',
  PrimaryActiveAddress: 'Primäre aktive Adresse'
}

const MISMATCH_TYPE_LABELS = {
  Person: 'Person',
  Address: 'Adresse',
  PersonNotFound: 'Person nicht gefunden',
  AddressNotFound: 'Adresse nicht gefunden',
  Institution: 'Institution',
  NotFound: 'SM-Eintrag nicht gefunden',
  0: 'Person',
  1: 'Adresse',
  2: 'Person nicht gefunden',
  3: 'Adresse nicht gefunden',
  4: 'Institution',
  5: 'SM-Eintrag nicht gefunden'
}

const ADDRESS_MATCH_TYPE_LABELS = {
  PrimaryActive: 'Primär und aktiv',
  SecondaryWithSmId: 'Sekundär mit SM-Id',
  0: 'Primär und aktiv',
  1: 'Sekundär mit SM-Id'
}

export function translateDifferingFields (value) {
  if (!value) {
    return value
  }

  return value
    .split(',')
    .map(field => field.trim())
    .filter(field => field.length > 0)
    .map(field => FIELD_LABELS[field] || field)
    .join(', ')
}

export function translateMismatchType (value) {
  if (value === null || value === undefined || value === '') {
    return value
  }

  return MISMATCH_TYPE_LABELS[value] || value
}

export function translateAddressMatchType (value) {
  if (value === null || value === undefined || value === '') {
    return value
  }

  return ADDRESS_MATCH_TYPE_LABELS[value] || value
}

function normalizeFieldDiffItem (diff) {
  if (!diff || typeof diff !== 'object') {
    return null
  }

  return {
    field: diff.field ?? diff.Field ?? '',
    fieldLabel: diff.fieldLabel ?? diff.FieldLabel ?? '',
    locationValue: diff.locationValue ?? diff.LocationValue ?? '',
    smValue: diff.smValue ?? diff.SmValue ?? ''
  }
}

export function parseFieldDiffs (mismatch) {
  if (!mismatch) {
    return []
  }

  const raw = mismatch.fieldDiffs ?? mismatch.FieldDiffs
  if (!raw) {
    return []
  }

  let parsed = raw
  if (typeof raw === 'string') {
    try {
      parsed = JSON.parse(raw)
    } catch (e) {
      return []
    }
  }

  if (!Array.isArray(parsed)) {
    return []
  }

  return parsed.map(normalizeFieldDiffItem).filter(Boolean)
}

export function normalizeMismatchForDisplay (mismatch) {
  if (!mismatch) {
    return mismatch
  }

  const differingFields = mismatch.differingFields ?? mismatch.DifferingFields
  const mismatchType = mismatch.mismatchType ?? mismatch.MismatchType
  const addressMatchType = mismatch.addressMatchType ?? mismatch.AddressMatchType
  const fieldDiffs = parseFieldDiffs(mismatch)

  return {
    ...mismatch,
    differingFields: translateDifferingFields(differingFields),
    mismatchType: translateMismatchType(mismatchType),
    addressMatchType: translateAddressMatchType(addressMatchType),
    fieldDiffs
  }
}
